import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

let loadingTimer

/**
 * ページ遷移開始
 */
export const onPreRouteUpdate = () => {
  // 初回アクセス時は PageLoading を表示しない
  if (!sessionStorage.getItem("page-loaded")) {
    return
  }

  // 前回の状態をリセット
  document.body.classList.remove("is-page-loading-end")
  document.body.classList.remove("is-kv-start")

  // PageLoading を表示
  document.body.classList.add("is-page-loading")
}

/**
 * ページ遷移完了
 */
export const onRouteUpdate = ({ location }) => {
  // 初回アクセス
  // → TopLoading は TopLoading コンポーネント側で処理
  if (!sessionStorage.getItem("page-loaded")) {
    sessionStorage.setItem("page-loaded", "true")
    return
  }

  // 前回のタイマーをクリア
  clearTimeout(loadingTimer)

  /**
   * PageLoading の表示時間
   *
   * ここを変更すると、
   * ページ遷移時のローディング時間を変更できます。
   */
  loadingTimer = setTimeout(() => {
    // PageLoading を終了
    document.body.classList.remove("is-page-loading")
    document.body.classList.add("is-page-loading-end")

    /**
     * TOPページの場合のみ
     * PageLoading終了後にKVアニメーションを開始
     */
    if (location.pathname === "/") {
      // 念のため一度削除してから追加
      document.body.classList.remove("is-kv-start")

      // 少しだけ確実に再描画させてから追加
      requestAnimationFrame(() => {
        document.body.classList.add("is-kv-start")
      })
    }

    /**
     * PageLoading終了用classは
     * 700ms後に削除
     */
    setTimeout(() => {
      document.body.classList.remove("is-page-loading-end")
    }, 700)
  }, 800)
}